import { handleActions } from 'redux-actions';
import { PaymentConsentResponse } from '@airwallex/airwallex-payment-elements';
import { CardType } from '../../views/issuingIcon';

export const PAYMENT_CONSENT_ACTION = 'CHECKOUT/PAYMENTCONSENT/SET';

export const GET_CONSENT_LIST_ACTION = 'CHECKOUT/CONSENT/LIST/SET';

export const PAYMENT_CONSENT_STATUS = 'CHECKOUT/PAYMENTCONSENT/SUBMITTING';

export type PaymentConsentState = {
  status?: 'INITIAL' | 'PROCESSING' | 'DONE' | 'ERROR';
  consent?: PaymentConsentResponse;
  paymentConsentList?: {
    id: string;
    brand: CardType;
    bin: string;
    last4: string;
    requires_cvc: boolean;
  }[];
};

export const reducer = handleActions(
  {
    [PAYMENT_CONSENT_ACTION]: (state, action) => ({
      ...state,
      consent: (action.payload as unknown) as PaymentConsentState['consent'],
    }),
    [GET_CONSENT_LIST_ACTION]: (state, action) => ({
      ...state,
      paymentConsentList: (action.payload as unknown) as PaymentConsentState['paymentConsentList'],
    }),
    [PAYMENT_CONSENT_STATUS]: (state, action) => ({
      ...state,
      status: (action.payload as unknown) as PaymentConsentState['status'],
    }),
  },
  {} as PaymentConsentState,
);

export default reducer;
